module.exports = __webpack_public_path__ + "img/nova-brasil-thati.aa791754.png";